import { pluralize } from '@rock/util';
import type { GuideNodeId } from '@rock/types';
import { outgoingHandles } from '@rock/types';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import type { FC } from 'react';
import type { ReturnNodeType } from './types';

export const ReturnNode: FC<NodeProps<ReturnNodeType>> = ({ id, data }) => {
    const handles = outgoingHandles.return(id as GuideNodeId, data);

    return (
        <div className="border-1 border-yellow-300 rounded-lg m-1 px-5 py-3 bg-yellow-100">
            <div className="text-md">Return</div>
            {handles.type === 'count' && (
                <div className="text-xs italic">
                    ({data.dismissCount || 0} {pluralize('screen', data.dismissCount || 0)})
                </div>
            )}
            {handles.type === 'edge' && <div className="text-xs italic">(edge target)</div>}
            <Handle type="target" position={Position.Left} />
            {handles.type === 'edge' && <Handle type="source" id={handles.returnTo} position={Position.Right} />}
        </div>
    );
};
